import { useEffect } from 'react';
import { optionsActions } from '../../store/reducers/optionsReducer';
import { useDispatch, useSelector } from 'react-redux';
import optionsSelectors from '../../store/selectors/optionsSelectors';
import { AppDispatch } from '../../../common/store';
import { IBuiltCar } from '../../../../../common/model/IBuiltCar';

const useProcessedAccessoriesAndPacks = (customisedCar: IBuiltCar) => {
  const dispatch: AppDispatch = useDispatch();
  const storeOptions = useSelector(optionsSelectors.getOptions);

  useEffect(() => {
    if (storeOptions) {
      dispatch(optionsActions.processAccessoriesCategories(customisedCar?.accessories ?? []));
      dispatch(optionsActions.processAccessoryPacks());
    }
  }, [storeOptions, customisedCar?.accessories]);
};

export default useProcessedAccessoriesAndPacks;
